// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled product card container
export const ProductCardContainer = styled.div`
    /* Appearance */
    background-color: white;
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    flex-direction: column;
    gap: 12px;

    /* Size */
    width: 250px;
    height: 250px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.5);

    /* Spacing */
    padding: 15px;

    /* Events */
    cursor: pointer;

    /* Mobile setup */
    @media (max-width: 600px) {
        width: 175px;
        height: 175px;

        padding: 10px;
        gap: 7px;
    }
`;

// Styled image div
export const ProductImageContainer = styled.div`
    /* Element disposition */
    position: relative;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Size */
    width: 100%;
    height: 80%;

    flex-shrink: 0;

    //border: 1px red solid;
`;

// Styled product image
export const ProductImage = styled.img`
    /* Element disposition */
    object-fit: cover;
    object-position: center;

    /* Size */
    width: 100%;
    height: 100%;

    /* Visual effects */
    box-shadow: 0px 4px 6px hsla(0, 0%, 0%, 0.3);
`;

export const ProductPriceCard = styled.div`
    /* Appearance */
    background-color: ${colors.primaryLightBrown};

    /* Size */
    height: 25px;

    /* Element disposition */
    position: absolute;
    top: 0;
    left: -15px;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Spacing */
    padding: 10px;
    padding-right: 15px;

    /* Visual effects */
    box-shadow: 0px 4px 6px hsla(0, 0%, 0%, 0.3);
    clip-path: polygon(0 0, 100% 0, calc(100% - 10px) 50%, 100% 100%, 0 100%);

    /* Mobile setup */
    @media (max-width: 600px) {
        left: -10px;
    }
`;

export const ProductPrice = styled.p`
    /* Appearance */
    color: ${colors.textWhite};
`;

export const ProductOfferCard = styled.div`
    /* Appearance */
    background-color: ${colors.secondaryRedBrown};
    box-shadow: 0px 4px 6px hsla(0, 0%, 0%, 0.3);

    /* Size */
    height: 25px;

    /* Element disposition */
    position: absolute;
    bottom: 0;
    right: -15px;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Spacing */
    padding: 10px;
    padding-left: 15px;

    /* Visual effects */
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 10px 50%);

    /* Mobile setup */
    @media (max-width: 600px) {
        right: -10px;
    }
`;

export const ProductOffer = styled.p`
    /* Appearance */
    color: ${colors.textWhite};
`;

export const ProductButton = styled.button`
    /* Appearance */
    background-color: ${colors.primaryBeige};
    border-radius: 10px;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Size */
    flex-grow: 1;

    /* Spacing */
    padding: 5px;

    /* Visual effects */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }

    /* Mobile setup */
    @media (max-width: 600px) {
        padding: 2px;
    }
`;

export const ProductTitle = styled.p`
    /* Appearance */
    color: ${colors.textWhite};

    /* Size */
    width: 90%;

    /* Events */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
